import { graphql } from "@/gql";

export const bookingChangeRequestQuoteQuery = graphql(`
  query BookingChangeRequestQuote(
    $bookingUuid: String!
    $input: BookingChangeRequestQuoteInput!
  ) {
    bookingChangeRequestQuote(bookingUuid: $bookingUuid, input: $input) {
      type
      currency
      admin_fee_amount
      price_delta_amount
      amount
    }
  }
`);
